import {CSSProperties, FC} from 'react'
import {PaginationState} from '../models'

type PaginationProps = {
  pagination: PaginationState
  isLoading: boolean
  updateState: (updates: Partial<any>) => void
}

const btnStyle = (disabled: boolean): CSSProperties => ({
  minWidth: 44,
  height: 40,
  padding: '0 14px',
  border: 'none',
  borderRadius: 10,
  background: disabled ? '#eceef0' : '#f2f4f6',
  color: '#191c1e',
  fontWeight: 700,
  fontSize: 16,
  lineHeight: 1,
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.55 : 1,
  flex: '0 0 auto',
})

const Pagination: FC<PaginationProps> = ({pagination, isLoading, updateState}) => {
  const totalPages = Number(pagination?.totalPages || 0)
  const currentPage = Number(pagination?.currentPage || 0)
  const pageSize = Number(pagination?.pageSize || 10)

  if (totalPages <= 1) {
    return null
  }

  const goTo = (page: number) => {
    if (isLoading || page === currentPage || page < 0 || page >= totalPages) {
      return
    }
    updateState({page, size: pageSize, pageSize})
  }

  const prevDisabled = isLoading || currentPage <= 0
  const nextDisabled = isLoading || currentPage >= totalPages - 1

  return (
    <div
      className='bo-pagination'
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        width: '100%',
        marginTop: 16,
        padding: '4px 0 8px',
      }}
    >
      <button
        type='button'
        aria-label='Previous'
        disabled={prevDisabled}
        onClick={() => goTo(currentPage - 1)}
        style={btnStyle(prevDisabled)}
      >
        ‹
      </button>
      <span
        style={{
          fontSize: 13,
          fontWeight: 700,
          color: '#191c1e',
          whiteSpace: 'nowrap',
          minWidth: 72,
          textAlign: 'center',
        }}
      >
        {currentPage + 1} / {totalPages}
      </span>
      <button
        type='button'
        aria-label='Next'
        disabled={nextDisabled}
        onClick={() => goTo(currentPage + 1)}
        style={btnStyle(nextDisabled)}
      >
        ›
      </button>
    </div>
  )
}

export {Pagination}
